import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient"; // varmista että polku on oikein

export default function AuthCallbackHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuth = async () => {
      const { data, error } = await supabase.auth.getSession();

      if (data?.session) {
        navigate("/", { replace: true }); // siirrytään etusivulle
      } else {
        console.error("Virhe kirjautumisessa:", error);
      }
    };

    handleAuth();
  }, [navigate]);

  return <div></div>;
}
